"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Row = exports.Column = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Table.scss");

require("./TableDark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Table = function Table(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-table ".concat(className)
  }, children);
};

var Row = function Row(_ref2) {
  var children = _ref2.children,
      type = _ref2.type,
      position = _ref2.position,
      assigned = _ref2.assigned,
      selected = _ref2.selected,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-table-row ".concat(type === 'header' || type === 'footer' ? 'gcl-' + type : '', " ").concat(position, " ").concat(className).concat(assigned ? ' assigned' : '').concat(selected ? ' selected' : '')
  }, children);
};

exports.Row = Row;

var Column = function Column(_ref3) {
  var children = _ref3.children,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-table-column ".concat(className)
  }, children);
};

exports.Column = Column;
Table.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string
};
Row.propTypes = {
  children: _propTypes["default"].node,
  type: _propTypes["default"].oneOf(['header', 'footer', '']),
  position: _propTypes["default"].oneOf(['fixed', '']),
  assigned: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
Row.defaultProps = {
  type: '',
  position: ''
};
Column.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string
};
var _default = Table;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Table/Table.js
// module id = 1930
// module chunks = 0